"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function _default(theme, props) {
  var palette = theme.palette;

  if (props.error) {
    theme.labelColor = theme.errorLabelColor;
  }

  return {
    root: {
      position: 'relative',
      font: "".concat(palette.tsNormal, "/").concat(palette.tlNormal, " \"").concat(palette.fontFamily, "\""),
      userSelect: 'none',
      display: 'inline-block',
      // overflow: 'hidden',
      verticalAlign: 'bottom',
      width: theme.width,
      minWidth: theme.minWidth
    },
    label: {
      textAlign: 'left',
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      color: theme.labelColor
    },
    input: {// padding: `${theme.gutter}px 0`,
    },
    wrapper: {
      border: "".concat(theme.borderWidth, " ").concat(theme.borderStyle, " ").concat(theme.borderColor),
      background: theme.background,
      borderRadius: theme.borderRadius,
      position: 'relative',
      // overflow: 'hidden',
      display: 'flex'
    },
    mask: {
      position: 'absolute',
      transform: 'translateX(0)',
      left: 0,
      zIndex: 2,
      top: (0, _pixelToNumber["default"])(theme.borderWidth) * -1,
      background: theme.maskBackground,
      borderRadius: theme.borderRadius,
      padding: theme.padding,
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'transform, width, background-color, color, box-shadow',
      boxSizing: 'border-box',
      boxShadow: theme.maskBoxShadow,
      color: theme.maskColor,
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      flex: 1,
      justifyContent: 'center',
      border: "".concat(theme.borderWidth, " ").concat(theme.maskBorderStyle, " ").concat(theme.maskBorderColor),
      '&:hover': {
        background: theme.hoverMaskBackground,
        color: theme.hoverMaskColor,
        boxShadow: theme.hoverMaskBoxShadow,
        border: "".concat(theme.borderWidth, " ").concat(theme.hoverMaskBorderStyle, " ").concat(theme.hoverMaskBorderColor)
      },
      '&:active': {
        background: theme.hoverMaskBackground,
        color: theme.hoverMaskColor,
        boxShadow: theme.hoverMaskBoxShadow,
        border: "".concat(theme.borderWidth, " ").concat(theme.hoverMaskBorderStyle, " ").concat(theme.hoverMaskBorderColor)
      }
    },
    field: {
      display: 'none'
    },
    fieldLabel: {
      position: 'relative',
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      color: theme.color,
      background: 'transparent',
      boxSizing: 'border-box',
      padding: theme.padding,
      borderRadius: theme.borderRadius,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'background-color, color, box-shadow',
      display: 'inline-flex',
      flex: 1,
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      zIndex: 1,
      boxShadow: theme.boxShadow,
      '& >*': {
        display: 'inline-block'
      },
      '&:hover': {
        color: theme.hoverColor,
        background: theme.hoverBackground,
        cursor: 'pointer',
        boxShadow: theme.hoverBoxShadow
      },
      '&:active': {
        background: theme.activeBackground,
        color: theme.activeColor,
        boxShadow: theme.activeBoxShadow
      }
    }
  };
}